/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Assignments Layout
 *
 * @file AssignmentsLayout.jsx
 * @author Gladson Samuel S
 * @since 2.0.0
 */

import React from 'react';
import PropTypes from 'prop-types';
import { AssignmentsStylesRoot, classes } from './styles/assignmentsStyles';

const AssignmentsLayout = ({ children, variant = 'split', classes: classesProp }) => {
  const defaultPaneRowClass = variant === 'single' ? classes.paneRowSingle : classes.paneRow;
  const paneRowClass = [defaultPaneRowClass, classesProp?.paneRow].filter(Boolean).join(' ');

  return (
    <AssignmentsStylesRoot className={classes.root}>
      <div className={paneRowClass}>
        {children}
      </div>
    </AssignmentsStylesRoot>
  );
};

AssignmentsLayout.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['single', 'split']),
  classes: PropTypes.shape({
    paneRow: PropTypes.string
  })
};

AssignmentsLayout.defaultProps = {
  variant: 'split',
  classes: null
};

export default AssignmentsLayout;
